import { ShopifyGqlIdType } from "@intelligems/ig-types";

export const toGqlId = (id: string, type: ShopifyGqlIdType): string => {
  if (id.includes("gid")) {
    return id;
  }
  return `gid://shopify/${type}/${id}`;
};

export const fromGqlId = (gqlId: string): string => {
  return gqlId.split("/").pop() || "";
};
